import React, { useMemo } from 'react';
import { Link } from 'react-router';
import './Hero.css';
import heroPhoto from './assets/Br6Dp.jpeg';
import BallisticNumber from '../shared/BallisticNumber';
import SampleTag from '../shared/SampleTag';
import {
    buildZoneRows,
    EXAMPLE_CSS_LABEL,
    formatZoneTime
} from '../shared/zonesData';

export default function Hero() {
    const rows = useMemo(() => buildZoneRows(100), []);

    return (
        <section
            id='hero'
            className='lp-hero lp-dark'
            style={{ '--lp-hero-photo': `url(${heroPhoto})` }}
        >
            <div className='lp-wrap lp-hero-grid'>
                <div className='lp-hero-copy'>
                    <h1>
                        Your numbers
                        <br />
                        write the plan.
                    </h1>
                    <p className='lp-hero-sub'>
                        For swimmers and coaches: a timed test set sets your pace zones, and those
                        zones drive every program.
                    </p>
                    <div className='lp-hero-actions'>
                        <Link to='/login' className='lp-btn'>
                            Start your first test
                        </Link>
                        <a href='#services' className='lp-btn lp-btn-quiet'>
                            See the zone math
                        </a>
                    </div>
                </div>

                <figure className='lp-readout' aria-label='A test result converted into pace zones'>
                    <figcaption className='lp-readout-head'>
                        <span className='lp-readout-title'>Test result to pace zones</span>
                        <SampleTag>Example</SampleTag>
                    </figcaption>
                    <dl className='lp-readout-input'>
                        <div>
                            <dt>Test</dt>
                            <dd>Test set</dd>
                        </div>
                        <div>
                            <dt>CSS</dt>
                            <dd className='lp-num'>{EXAMPLE_CSS_LABEL}</dd>
                        </div>
                    </dl>
                    <ul className='lp-readout-zones'>
                        {rows.map(row => (
                            <li key={row.title}>
                                <span className='lp-readout-zone'>{row.title}</span>
                                <span className='lp-readout-name'>{row.subTitle}</span>
                                <BallisticNumber
                                    className='lp-readout-pace'
                                    value={row.average}
                                    from={row.average * 1.18}
                                    format={formatZoneTime}
                                    text={row.averageText}
                                />
                            </li>
                        ))}
                    </ul>
                    <p className='lp-readout-foot'>Average pace per 100m, from the zones the app calculates.</p>
                </figure>
            </div>
        </section>
    );
}
